import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_storage_baskets: FaireCategoryEntity = {
  token: "cat_storage-baskets",
  type: "category",
  name: "Baskets & boxes",
  level: 3,
  parentToken: "cat_home-decor-storage",
  href: "/category/home-decor/storage-organization/baskets-boxes",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
